import React, {useMemo, useRef, useState} from 'react';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Alert, Collapse, Divider, Input, Radio, Select} from "antd";
import Interview from "../../../models/Interview";
import {useAuth} from "../../../providers/AuthProvider";
import SpinLoader from "../../../components/SpinLoader";

const TalentCapabilityAssessmentModal = (props) => {

    // let talent = props.talent;

    const formRef = useRef(null);
    const {auth} = useAuth();
    const [formModel, setFormModel] = useState(() => {
        let interview = TB.pick({...props.talent}, [
            'talent_disciplines',
            'talent_service_groups',
            'skills',
            'talent_skill_score'
        ]);

        return TB.cloneDeep({...interview});
    });

    const [changeCount, setChangeCount] = useState(0)

    const profileScoring = () => {
        return [
            {
                label: 'Roles',
                propName: 'talent_disciplines',
                scorable: true
            },
            {
                label: 'Skills',
                propName: 'skills'
            },
            {
                label: 'Project Interests',
                propName: 'talent_service_groups',
                scorable: true
            },
            {
                label: 'Industry Experience',
                propName: 'industries_worked'
            }
        ]
    }
    let scorableProfiles = TB.filter(profileScoring(), ['scorable', true]);

    const sectionSummaries = useMemo(() => {
        if (!formModel) {
            return {}
        }

        let summary = {}
        TB.map(scorableProfiles, (group) => {
            let groupName = group.propName;
            let items = props.talent[groupName]
            let itemsGrouped = TB.groupBy(formModel[groupName] || [], scoreItem => {
                return Interview.marketplaceStatus(groupName,scoreItem, true)?.title
            })

            summary[groupName] = (
                <p className="flex flex-row items-center gap-1.5">
                    <span className="font-medium text-xs">{items?.length || 0} Total</span>
                    {TB.map(itemsGrouped, (items, groupName) => groupName && groupName !== 'undefined' && items.length > 0 && (
                        <span key={`summary-${groupName}`} className={`text-xs font-medium px-1.5 py-0.5 rounded ${
                            groupName.includes('Not Approved') ? 'bg-red-100 text-red-800' : (
                                groupName.includes('Pending') ? 'bg-yellow-100 text-yellow-800' : (
                                    groupName?.includes('Approved') ? 'bg-green-100 text-green-800' : ''
                                )
                            )}`}>
                            {items.length} {groupName}
                        </span>
                    ))}
                </p>
            );
        })
        return summary
    }, [formModel?.talent_service_groups,formModel?.talent_disciplines, changeCount]);

    const selfScore = (score) => {
        return laravel.talent_scoring_options[score]
    }

    const type = () => {
        return props.type
    }


    const onChange = async (model) => {
        let assessment = {
            ...formModel
        };
        for (let [prop, value] of Object.entries(model)) {
            assessment = TB.set(assessment, prop, value)
        }
        console.log('onChange', assessment)
        await setFormModel(assessment);
        setChangeCount(changeCount + 1)
    }

    const hasStarted = useMemo(() => {
        if (!props.talent) {
            return false;
        }
        let interview = props.talent.managerInterview();
        return interview?.assessmentStarted('capability');
    }, [props.talent]);

    const hasAssessmentChanged = useMemo(() => {
        if (!props.talent) {
            return false;
        }
        let change = props.talent.talent_skill_score !== formModel.talent_skill_score;
        TB.map(scorableProfiles,({label, propName}) => {
            let items = formModel[propName]

            TB.map(items,scoreItem => {
                const hasChanged = !TB.isEqual(scoreItem, TB.find(props.talent[propName], ['id', scoreItem.id]));

                if (hasChanged) {
                    change = true;
                }
            })
        })
        return change
    }, [changeCount]);


    return formModel && (
        <SpinLoader isLoading={props.isDisabled} className="flex flex-col items-stretch">
            <Form
                ref={formRef}
                title={null}
                subtitle={null}
                showRequired
                minimal
                submitButton={false}
                onSubmit={async () => {
                    console.log('assement update', formModel);

                    let confirm = true;
                    if (Interview.make(formModel).capabilityMissingScores()) {
                        confirm = await TB.alert('warning', 'Assessment Not Finished',
                            'The assessment has missing scores or pending approval decisions. Are you sure you want to submit your decision?',
                            [{title: 'Yes, Continue'}, {title: 'Cancel'}]
                        );
                    }
                    if (confirm) {
                        return props.submitAssessment(formModel)
                    }
                }}
                onChange={onChange}
                model={formModel}
                fields={[]}
                isDisabled={props.isDisabled}>

                {TB.map(scorableProfiles, ({label, propName}, index) => {
                    let items = formModel[propName]

                    if (!items?.length) {
                        return null;
                    }
                    return (
                        <div key={`section-${label}-${propName}`}
                             className="flex flex-col items-stretch gap-1 mt-6">
                            <div className="flex flex-row items-center gap-3 mb-6">
                                <h5 className="assessment-section-header text-left whitespace-no-wrap">
                                    {label}
                                </h5>
                                {sectionSummaries[propName]}

                            </div>

                            <Collapse
                                defaultActiveKey={index === 0 ? [`section-panel-${propName}-0`] : []}
                                onChange={console.log}
                                expandIconPosition={'end'}
                            >
                                {TB.map(items, (scoreItem, index) => {
                                    let hasSelfScore = TB.isDefined(scoreItem.self_score);

                                    let status = Interview.marketplaceStatus(propName, scoreItem);
                                    const hasChanged = !TB.isEqual(scoreItem, TB.find(props.talent[propName], [
                                        'id',
                                        scoreItem.id
                                    ]));
                                    return (
                                        <Collapse.Panel
                                            header={<div
                                                className="assessment-section-subheader flex flex-row items-end justify-between gap-5">
                                                <div className="basis-full">
                                                    <div
                                                        className="flex flex-row items-center justify-start gap-5 basis-full">
                                                        <h5 className="mb-0">
                                                            <span>
                                                                {TB.startCase(scoreItem.name)}
                                                            </span>

                                                            {hasSelfScore && (
                                                                <span className="self-score">
                                                                    Talent Self
                                                                    Score: &nbsp;{selfScore(scoreItem.self_score)}
                                                                </span>
                                                            )}
                                                        </h5>

                                                        {status?.title && (
                                                            <div className="ml-auto min-w-[350px] text-left">
                                                                <p>
                                                                    <span className="font-semibold text-xs">
                                                                        Status:&nbsp;
                                                                    </span>

                                                                    <span
                                                                        className={`text-xs font-medium px-1.5 py-0.5 rounded ${status.className}`}>
                                                                        {status.title}
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <p className="my-4">
                                                        {TB.startCase(scoreItem.description)}
                                                    </p>
                                                    <span
                                                        className="absolute right-3 bottom-3 inline italic text-gray text-xxs">
                                                        {hasChanged ? 'Changes Pending..' : null}
                                                    </span>
                                                </div>

                                            </div>}
                                            key={`section-panel-${propName}-${index}`}>


                                            <div className="flex flex-col gap-3 items-stretch w-[900px] max-w-full">
                                                <div className="flex flex-row items-start justify-start gap-5">

                                                    {propName === 'talent_disciplines' && (
                                                        <div className="min-w-[200px] flex items-stretch flex-col">
                                                            <div
                                                                className="transition-all ease-in form-group  flex flex-col">
                                                                <label htmlFor="" className="col-form-label">
                                                                    Hourly Rate
                                                                </label>
                                                                <div className="h-[32px] flex flex-col justify-center ">
                                                                    <p className="text-sm">
                                                                        ${scoreItem?.hourly_rate} per hour
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div
                                                        className="min-w-[275px] flex items-stretch flex-col">
                                                        <FormInputComponent
                                                            fieldName={`${propName}[${index}].wripple_score`}
                                                            label="Score"
                                                            className="flex flex-col"
                                                            value={scoreItem?.wripple_score}
                                                            type="rating"
                                                            required={false}
                                                        />
                                                    </div>

                                                    <div className="min-w-[250px]">
                                                    <FormInputComponent
                                                            fieldName={`${propName}[${index}].level`}
                                                            value={scoreItem?.level}
                                                            label="Level"
                                                            type="antd-input"
                                                            required={false}
                                                        >

                                                            <Select placeholder="Select an option"
                                                                    options={TB.map(laravel.talent_discipline_levels, (label, value) => {
                                                                        return {
                                                                            label,
                                                                            value: parseInt(value)
                                                                        }
                                                                    })}/>

                                                        </FormInputComponent>
                                                    </div>
                                                </div>
                                                {propName === 'talent_disciplines' && (
                                                    <div className="flex flex-col gap-1.5 items-stretch">
                                                        <label htmlFor=""
                                                               className="col-form-label">
                                                            Marketplace Status
                                                        </label>
                                                        <Radio.Group
                                                            className="flex-1"
                                                            value={scoreItem?.is_approved ? 'approved' : (
                                                                scoreItem?.is_rejected ? 'rejected' : undefined
                                                            )} onChange={e => {
                                                            let assessment = {...formModel};

                                                            switch (e.target.value) {
                                                                case 'approved':
                                                                    assessment = TB.set(assessment, `${propName}[${index}].is_approved`, true);
                                                                    if (propName === 'talent_disciplines') {
                                                                        assessment = TB.set(assessment, `${propName}[${index}].is_rejected`, false);
                                                                    }
                                                                    break;
                                                                case 'rejected':
                                                                    assessment = TB.set(assessment, `${propName}[${index}].is_approved`, false);
                                                                    if (propName === 'talent_disciplines') {
                                                                        assessment = TB.set(assessment, `${propName}[${index}].is_rejected`, true);
                                                                    }
                                                                    break;
                                                            }
                                                            setFormModel(assessment)
                                                            setChangeCount(changeCount + 1)
                                                        }}>
                                                            <Radio value="approved">
                                                                <span>
                                                                    Approved
                                                                </span>
                                                            </Radio>
                                                            <Radio value="rejected">
                                                                <span>
                                                                    Rejected
                                                                </span>
                                                            </Radio>
                                                        </Radio.Group>
                                                    </div>
                                                )}
                                                {propName === 'talent_disciplines' && (scoreItem?.is_rejected || scoreItem?.rejection_notes) && (
                                                    <FormInputComponent
                                                        fieldName={`${propName}[${index}].rejection_notes`}
                                                        value={scoreItem?.rejection_notes}
                                                        label={(
                                                            <span
                                                                className="flex flex-row items-center justify-between gap-5">
                                                                <span
                                                                    className="font-medium">
                                                                    Rejection Notes
                                                                </span>
                                                                <span className="text-danger">
                                                                    <b>Note:</b> This <b>WILL</b> be visible to talent
                                                                </span>
                                                            </span>
                                                        )}
                                                        placeholder={"Give feedback to the talent for reason why role was not approved"}
                                                        type={'antd-input'}
                                                        required={false}
                                                        className="flex-1"
                                                        maxLength={2000}
                                                    >
                                                        <Input.TextArea
                                                            rows={4}
                                                            disabled={!scoreItem?.is_rejected}
                                                        />
                                                    </FormInputComponent>
                                                )}

                                                {propName === 'talent_disciplines' && !scoreItem?.is_approved && scoreItem?.latest_appeal && (
                                                    <React.Fragment>
                                                        <div
                                                            className="flex flex-row items-start gap-5 justify-between">
                                                            <div className="flex-1">
                                                                <Alert
                                                                    message="Talent Submitted Appeal For Approval"
                                                                    type="warning"
                                                                    showIcon
                                                                    description={(
                                                                        <div
                                                                            className="flex flex-col gap-3 items-stretch mt-2.5">
                                                                            <div>
                                                                                <p className="text-sm col-form-label font-medium">
                                                                                    Date Requested:
                                                                                </p>
                                                                                <p className="text-sm">
                                                                                    {TB.moment(scoreItem.latest_appeal?.created_at).format('llll')}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="text-sm col-form-label font-medium">
                                                                                    Message from talent:
                                                                                </p>
                                                                                <p className="text-sm">
                                                                                    {scoreItem.latest_appeal?.notes || 'No reason given'}
                                                                                </p>
                                                                            </div>

                                                                            <div
                                                                                className="flex flex-col gap-5 justify-between items-stretch flex-1">
                                                                                <div
                                                                                    className="flex flex-col gap-1.5 items-stretch">
                                                                                    <label
                                                                                        className="col-form-label font-medium">
                                                                                        Appeal Decision:
                                                                                    </label>
                                                                                    <Radio.Group
                                                                                        value={scoreItem.latest_appeal?.is_approved ? 'approved' : (
                                                                                            scoreItem.latest_appeal?.is_rejected ? 'rejected' : undefined
                                                                                        )} onChange={e => {
                                                                                        let assessment = {...formModel};

                                                                                        switch (e.target.value) {
                                                                                            case 'approved':
                                                                                                assessment = TB.set(assessment, `${propName}[${index}].latest_appeal.is_approved`, true);
                                                                                                assessment = TB.set(assessment, `${propName}[${index}].latest_appeal.is_rejected`, false);
                                                                                                break;
                                                                                            case 'rejected':
                                                                                                assessment = TB.set(assessment, `${propName}[${index}].latest_appeal.is_approved`, false);
                                                                                                assessment = TB.set(assessment, `${propName}[${index}].latest_appeal.is_rejected`, true);
                                                                                                break;
                                                                                        }
                                                                                        setFormModel(assessment)
                                                                                        setChangeCount(changeCount + 1)
                                                                                    }}>
                                                                                        <Radio
                                                                                            value="approved">
                                                                                            <span>
                                                                                                Accept and
                                                                                                Approve
                                                                                            </span>
                                                                                        </Radio>
                                                                                        <Radio
                                                                                            value="rejected">
                                                                                            <span>
                                                                                                Reject
                                                                                                Approval
                                                                                            </span>
                                                                                        </Radio>
                                                                                    </Radio.Group>

                                                                                </div>
                                                                                {(scoreItem?.latest_appeal?.is_rejected || scoreItem?.latest_appeal?.rejection_notes) ? (
                                                                                    <FormInputComponent
                                                                                        fieldName={`${propName}[${index}].latest_appeal.rejection_notes`}
                                                                                        value={scoreItem.latest_appeal?.rejection_notes}
                                                                                        className="mt-4"
                                                                                        labelClassName="flex flex-row items-center gap-3"
                                                                                        label={(
                                                                                            <span className="flex-grow flex flex-row items-center justify-between gap-5">
                                                                                                <span className="font-medium">Appeal Rejection Feedback</span>
                                                                                                <span className="text-danger">
                                                                                                    <b>Note:</b> This <b>WILL</b> be visible to talent
                                                                                                </span>
                                                                                            </span>
                                                                                        )}
                                                                                        placeholder={"Give feedback as to why this request was denied"}
                                                                                        type={'antd-input'}
                                                                                        required={scoreItem.latest_appeal?.is_rejected}
                                                                                        maxLength={2000}
                                                                                        rows={4}
                                                                                    >
                                                                                        <Input.TextArea
                                                                                            rows={4}
                                                                                            disabled={!scoreItem.latest_appeal?.is_rejected}
                                                                                        />

                                                                                    </FormInputComponent>
                                                                                ) : <div className="mt-3"/>}
                                                                            </div>
                                                                            <FormInputComponent
                                                                                fieldName={`${propName}[${index}].latest_appeal.admin_decision`}
                                                                                value={scoreItem.latest_appeal?.admin_decision}
                                                                                className="mt-4"
                                                                                label={(
                                                                                    <span
                                                                                        className="flex flex-row items-center justify-between gap-5">
                                                                                        <span className="font-medium">Reason For Appeal Decision <i>(required)</i>
                                                                                        </span>
                                                                                        <span className="text-danger">
                                                                                            <b>Note:</b> This <b>WILL NOT</b> be visible to talent
                                                                                        </span>
                                                                                    </span>
                                                                                )}
                                                                                placeholder={"Explain the reasoning for the decision"}
                                                                                type={'antd-input'}
                                                                                maxLength={2000}
                                                                                rows={4}
                                                                            >
                                                                                <Input.TextArea
                                                                                    rows={4}
                                                                                />

                                                                            </FormInputComponent>
                                                                        </div>
                                                                    )}
                                                                />

                                                            </div>

                                                        </div>


                                                    </React.Fragment>
                                                )}
                                                <FormInputComponent
                                                    fieldName={`${propName}[${index}].admin_decision`}
                                                    value={scoreItem?.admin_decision}
                                                    labelClassName="flex flex-row items-center gap-3"
                                                    label={(
                                                        <span className="flex-grow flex flex-row items-center justify-between gap-5">
                                                            <span className="font-medium">Reason For {propName === 'talent_disciplines' ? "Decision" : "Score"} <i>(required)</i></span>
                                                            <span className="text-danger">
                                                                <b>Note:</b> This <b>WILL NOT</b> be visible to talent
                                                            </span>
                                                        </span>
                                                    )}
                                                    disabled={propName === 'talent_disciplines' && !scoreItem?.is_approved && !scoreItem?.is_rejected}
                                                    className="mt-4"
                                                    placeholder={"Explain the reasoning for the decision"}
                                                    type={'antd-input'}
                                                    required={true}
                                                    maxLength={2000}
                                                >
                                                    <Input.TextArea
                                                        rows={4}
                                                    />

                                                </FormInputComponent>

                                                <FormInputComponent
                                                    fieldName={`${propName}[${index}].admin_notes`}
                                                    value={scoreItem?.admin_notes}
                                                    label={(
                                                        <span className="flex flex-row items-center justify-between gap-5">
                                                            <span className="font-medium">Admin Notes <i>(optional)</i></span>
                                                            <span className="text-danger">
                                                                <b>Note:</b> This <b>WILL NOT</b> be visible to talent
                                                            </span>
                                                        </span>
                                                    )}
                                                    className="mt-4"
                                                    placeholder={"Write any additional administrative notes here"}
                                                    type={'antd-input'}
                                                    required={false}
                                                    maxLength={2000}
                                                >
                                                    <Input.TextArea
                                                        rows={4}
                                                    />

                                                </FormInputComponent>
                                            </div>


                                        </Collapse.Panel>
                                    )
                                })}


                            </Collapse>


                            <div className="my-3 w-full">
                                <Divider/>
                            </div>
                        </div>
                    )
                })}
                <div className="flex flex-col items-stretch gap-1 mt-6">
                    <div className="flex flex-row items-center gap-3">
                        <h5 className="assessment-section-header text-left whitespace-no-wrap">
                            Talent Skills
                        </h5>

                    </div>
                    <div className="assessment-skills-container">
                        <p className="skills-score-subheader text-left mx-0 mt-2 max-w-[unset]">
                            Below are the talent's selected skills with experience rating. For the skills
                            selected, set a confidence level based on deep dives into roles and projects
                        </p>
                        <div className="flex flex-row w-100 talent-skills">
                            <div className="discipline-skills-container">
                                {formModel?.skills.map((skill, index) => (
                                    <span className="dropdown" key={`skill-${skill.id}`}>
                                        <span className="skill selected z-10">
                                            <p>
                                                {skill.name}
                                            </p>
                                        </span>
                                        {skill.self_score && (
                                            <span className="skill-result skill">
                                                <p>{selfScore(skill.self_score)}</p>
                                            </span>
                                        )}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="max-w-[500px] mx-auto mb-6">
                            <FormInputComponent
                                fieldName={`talent_skill_score`}
                                value={formModel?.talent_skill_score}
                                label="Talent Skill Confidence Level"
                                className="talent-skill-rating"
                                type="rating"
                                required={false}
                            >

                            </FormInputComponent>
                        </div>

                    </div>


                </div>


                <div className="assessment-form-actions mt-10">
                    <button type="button" disabled={props.isDisabled}
                            onClick={async () => {
                                return props.onClose()
                            }} className="btn btn-dark btn-sm mx-2">
                        Cancel
                    </button>

                    {hasStarted ? (
                        <button type="submit"
                                disabled={props.isDisabled || !hasAssessmentChanged}
                                className="btn btn-primary btn-sm mx-2">
                            Update Assessment
                        </button>
                    ) : [
                        <button key="save-form-btn"
                                type="submit"
                                disabled={props.isDisabled || !hasAssessmentChanged}
                                className="btn btn-xs btn-primary mx-2">
                            Save Assessment
                        </button>,
                        <button key="approve-form-btn"
                                type="button"
                                onClick={() => props.approveAssessment(formModel)}
                                disabled={props.isDisabled}
                                className="btn btn-xs btn-success mx-2">
                            <i className="fas fa-thumbs-up"/>
                            Submit & Approve Talent
                        </button>,
                        <button key="reject-form-btn"
                                type="button"
                                onClick={() => props.rejectAssessment(formModel)}
                                disabled={props.isDisabled}
                                className="btn btn-xs btn-danger mx-2">
                            <i className="fas fa-thumbs-down"/>
                            Submit & Reject Talent
                        </button>
                    ]}

                </div>
            </Form>
        </SpinLoader>
    )
};

const CapabilityScoreSummary = (props) => {


    let interview = props.talent.managerInterview();
    let assessment = interview.capabilityAssessment();
    return (
        <div className="assessment-scoring">
            <div className="assessment-score-row">
                <div className="assessment-score-section">
                    <div className="score-label status b-dark">
                        <p className="mb-0">
                            Status
                        </p>
                    </div>
                    <div className={TB.mapClass("score-value status", {
                        approved: interview.capabilityWasApproved(),
                        rejected: !interview.capabilityWasApproved() && interview.capabilityWasRejected(),
                        incomplete: !interview.hasCapabilityStatus(),
                    })} style={{borderBottomColor: '#000!important'}}>
                        <p className="text-bold mb-0">
                            {interview.capabilityStatusDisplay()}
                        </p>
                    </div>
                </div>

                {interview.hasHRStatus() ? (
                    <React.Fragment>
                        <div className="assessment-score-section">
                            <div className="score-label status">
                                <p className="mb-0">
                                    {interview.capabilityWasApproved() ? 'Approved At' : 'Rejected At'}
                                </p>
                            </div>
                            <div className="score-value overall border-top-0">
                                {TB.moment((interview.capabilityWasApproved() ? interview.capability_approved_at : interview.capability_rejected_at) || 'now').format('ll')}
                            </div>
                        </div>
                        <div className="assessment-spacer"/>

                        <div className="assessment-score-section">
                            <div className="score-label overall border-top-0">
                                <p className="mb-0">
                                    {interview.capabilityWasApproved() ? 'Approved By' : 'Rejected By'}

                                </p>
                            </div>
                            <div className="score-value overall border-top-0">
                                <p className="text-bold mb-0">
                                    {interview.capabilityInterviewedBy()}
                                </p>
                            </div>
                        </div>
                    </React.Fragment>
                ) : (
                    <div className="assessment-spacer"/>
                )}
            </div>
            <div className="assessment-score-row mt-3">

                {TB.map(assessment.scores, (scores, name) => [
                    <div className="assessment-score-section" key={TB.slugify(name) + "-label"}>
                        <div className="score-label">
                            <p className="mb-0">
                                {TB.startCase(name)}
                            </p>
                        </div>
                        <div className="score-value">
                            <p className="text-bold mb-0">
                            {scores.length} Total
                            </p>
                        </div>
                    </div>,
                    <div className="assessment-score-section" key={TB.slugify(name) + "-score"}>
                    <div className="score-label">
                            <p className="mb-0">
                                Average Score
                            </p>
                        </div>
                        <div className="score-value">
                            <p className="text-bold mb-0">
                                {interview.capabilityAverageScore(name)}
                            </p>
                        </div>
                    </div>
                ])}
                <div className="assessment-score-section">
                    <div className="score-label">
                        <p className="mb-0">
                            Skills
                        </p>
                    </div>
                    <div className="score-value">
                        <p className="text-bold mb-0">
                            {assessment.skills.length} Total
                        </p>
                    </div>
                </div>
                <div className="assessment-score-section">
                    <div className="score-label">
                        <p className="mb-0">
                            Skill Confidence Rating
                        </p>
                    </div>
                    <div className="score-value">
                        <p className="text-bold mb-0">
                            {assessment.talent_skill_score ? (assessment.talent_skill_score + "/5") : 'N/A'}
                        </p>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default TalentCapabilityAssessmentModal;

export {
    CapabilityScoreSummary
}